define('plugin/invoice/view/InvoiceLayout',['require','lib/view/LayoutView','plugin/invoice/view/InvoiceDetailsView','plugin/invoice/view/InvoiceTotalsView','plugin/invoice/view/InvoicePaymentView','plugin/invoice/view/InvoicePaymentSystemView','plugin/invoice/view/InvoicePaymentButtonView','plugin/invoice/view/InvoicePaymentMethodView','plugin/invoice/view/InvoicePaymentSystemFreeView','plugin/invoice/view/InvoiceRebillingFlagView','plugin/invoice/view/InvoiceRecurringFlagView','plugin/invoice/view/InvoiceStatusView','plugin/invoice/view/InvoiceButtonsView','plugin/invoice/view/InvoicePayNowButtonView','view/module/MessageView','lib/terms/ClientTermsController','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var InvoiceDetailsView = require('plugin/invoice/view/InvoiceDetailsView');
    var InvoiceTotalsView = require('plugin/invoice/view/InvoiceTotalsView');
    var InvoicePaymentView = require('plugin/invoice/view/InvoicePaymentView');
    var InvoicePaymentSystemView = require('plugin/invoice/view/InvoicePaymentSystemView');
    var InvoicePaymentButtonView = require('plugin/invoice/view/InvoicePaymentButtonView');
    var InvoicePaymentMethodView = require('plugin/invoice/view/InvoicePaymentMethodView');
    var InvoicePaymentSystemFreeView = require('plugin/invoice/view/InvoicePaymentSystemFreeView');
    var InvoiceRebillingFlagView = require('plugin/invoice/view/InvoiceRebillingFlagView');
    var InvoiceRecurringFlagView = require('plugin/invoice/view/InvoiceRecurringFlagView');
    var InvoiceStatusView = require('plugin/invoice/view/InvoiceStatusView');
    var InvoiceButtonsView = require('plugin/invoice/view/InvoiceButtonsView');
    var InvoicePayNowButtonView = require('plugin/invoice/view/InvoicePayNowButtonView');
    var MessageView = require('view/module/MessageView');
    var ClientTermsController = require('lib/terms/ClientTermsController');
    var Config = require('Config');

    /**
     * Invoice layout. Contains regions for payment systems list, invoice info
     *
     * @class InvoiceLayout
     */
    return LayoutView.extend({

        template: '#invoice_layout',
        regions: {
            'deposit_info': '#sb_invoice_deposit_container',
            'invoice': '#sb_invoice_container',
            'invoice_totals': '#sb_invoice_totals_container',
            'payment_methods': '#sb_invoice_payment_methods_container',
            'payment_data': '#sb_invoice_payment_data_container',
            'recurring': '#sb_invoice_recurring_flag_container',
            'rebilling': '#sb_invoice_rebilling_flag_container',
            'notification': '#sb_invoice_notification',
            'payment_notification': '#sb_invoice_payment_notification',
            'promotion': '#sb_invoice_promotion_container',
            'tips': '#sb_invoice_tips_container',
            'promotion_list': '#sb_invoice_promotion_list_container',
            'used_package_list': '#sb_invoice_used_package_instance_list_container',
            'allowed_package_list': '#sb_invoice_allowed_package_instance_list_container',
            'package_notification_container': '#sb_invoice_package_notification_container',
            'buttons': '#sb_invoice_buttons_container',
            'payment_buttons': '#sb_invoice_payment_buttons_container',
            'terms': '#sb_terms_and_conditions_alert',
            'product_delivery': '#sb_product_delivery',
        },
        childEvents: {
            'payment_processor:select': 'triggerPaymentProcessorSelect',
            'payment_processor:recurring': 'triggerPaymentProcessorRecurringChanged',
            'payment_processor:rebilling': 'triggerPaymentProcessorRebillingChanged',
            'payment_processor:pay': 'triggerPayWithPaymentProcessor',
            'payment_processor:pay:free': 'triggerPayWithFreePaymentProcessor',
            'payment_processor:loaded': 'triggerPaymentProcessorLoaded',
            render: 'onChildRender',
        },
        _paymentSystemCollection: null,
        _paymentMethodCollection: null,
        _invoiceModel: null,

        initialize: function () {
            this._paymentSystemCollection = this.getOption('paymentSystemCollection');
            this._paymentMethodCollection = this.getOption('paymentMethodCollection');
            this._invoiceModel = this.getOption('invoiceModel');
            this._clientModel = this.getOption('clientModel');

            if(this._clientModel) {
                this._termsController = ClientTermsController.getInstance({
                    'client': this._clientModel
                });
                this._termsController.getModel().fetch();
            }
        },

        triggerPaymentProcessorSelect: function (model) {
            this.triggerMethod('payment_processor:select', model);
        },

        triggerPayWithPaymentProcessor: function () {
            this.triggerMethod('payment_processor:pay');
        },

        triggerPayWithFreePaymentProcessor: function () {
            this.triggerMethod('payment_processor:pay:free');
        },

        triggerPaymentProcessorRecurringChanged: function (data, flag) {
            this.triggerMethod('payment_processor:recurring', flag);
        },

        triggerPaymentProcessorRebillingChanged: function (data, flag) {
            this.triggerMethod('payment_processor:rebilling', flag);
        },

        triggerPaymentProcessorLoaded: function (data, paymentProcessor) {
            this.triggerMethod('payment_processor:loaded', paymentProcessor);
        },

        displayInvoiceData: function () {
            var view = new InvoiceDetailsView({
                model: this._invoiceModel,
                clientModel: this._clientModel,
                paymentAllowed: this.getOption('paymentAllowed'),
                isDirectLink: this.getOption('isDirectLink'),
            });

            this.showChildView('invoice', view);

            Backbone.Wreqr.radio.vent.trigger('invoice:layout', 'show', {
                view: this,
                model: this._invoiceModel,
                paymentAllowed: this.getOption('paymentAllowed')
            });
            
            this.showChildView('invoice_totals', new InvoiceTotalsView({
                model: this._invoiceModel
            }));

            this.showTermsAndConditions(this._termsController.getPromoAlertView());
        },

        showTermsAndConditions: function (view) {
            var invoiceType = null;

            if(this._invoiceModel) {
                var lines = this._invoiceModel.get('lines');
                if(lines) {
                    lines = lines.toJSON();
                    _.each(lines, function (line) {
                        if (line && line.type) {
                            invoiceType = line.type;
                        }
                    });
                }
            }

            if(invoiceType === 'promotion' && this._invoiceModel.get('status') === 'new') {
                try {
                    this.getRegion("terms")._ensureElement();
                    if(this.terms.$el.length){
                        this.showChildView('terms', view);
                    }
                } catch (e) {
                    //console.error(e);
                }
            }
        },

        displayPayNowButton: function () {
            this.payment_methods.reset();
            this.payment_data.reset();
            this.showChildView('payment_buttons', new InvoicePayNowButtonView({
                collection: this._paymentSystemCollection,
                model: this._invoiceModel
            }));
        },

        displayPaymentProcessors: function (confirmAllowed) {
            var config = Config.getInstance();
            if (config.getOption('rebilling_enabled')) {
                this.showChildView('payment_methods', new InvoicePaymentMethodView({
                    collection: this._paymentMethodCollection,
                    model: this._invoiceModel
                }));
            }
            this.showChildView('payment_data', new InvoicePaymentSystemView({
                collection: this._paymentSystemCollection,
                model: this._invoiceModel
            }));
            this.showChildView('payment_buttons', new InvoicePaymentButtonView({
                collection: this._paymentSystemCollection,
                model: this._invoiceModel,
                confirmAllowed: confirmAllowed
            }));
        },

        displayFreeButton: function () {
            this.payment_methods.reset();
            this.payment_data.reset();
            this.showChildView('payment_buttons', new InvoicePaymentSystemFreeView({
                model: this._invoiceModel
            }));
        },

        displayPayProcess: function (invoiceModel, paymentProcessorModel) {
            this.payment_methods.reset();
            this.payment_buttons.reset();
            this.showChildView('payment_data', new InvoicePaymentView({
                invoiceModel: invoiceModel,
                paymentSystemModel: paymentProcessorModel
            }));
        },

        displayRecurringFlag: function (paymentProcessorModel) {
            this.showChildView('recurring', new InvoiceRecurringFlagView({
                model: paymentProcessorModel
            }));
        },

        displayRebillingFlag: function (paymentProcessorModel) {
            var config = Config.getInstance();
            if (config.getOption('rebilling_enabled')) {
                this.showChildView('rebilling', new InvoiceRebillingFlagView({
                    model: paymentProcessorModel
                }));
            }
        },

        displayStatusMessage: function (model) {
            this.showChildView('notification', new InvoiceStatusView({
                model: model
            }));
        },

        displayPaymentMessage: function (message, type) {
            this.showChildView('payment_notification', new MessageView({
                message: message,
                type: type
            }));
        },

        displayButtons: function (showButtons) {
            this.showChildView('buttons', new InvoiceButtonsView({
                model: this._invoiceModel,
                showButtons: showButtons
            }));
        },

        hidePaymentMessage: function () {
            this.payment_notification.reset();
        },

        getDepositInfoRegion: function () {
            return this.deposit_info;
        },

        getPromotionCodeRegion: function () {
            return this.promotion;
        },

        getTipsRegion: function () {
            return this.tips;
        },

        getAllowedPackageInstancesRegion: function () {
            return this.allowed_package_list;
        },

        getUsedPackageInstancesRegion: function () {
            return this.used_package_list;
        },

        getPackageNotificationRegion: function () {
            return this.package_notification_container;
        },

        getPromotionListRegion: function () {
            return this.promotion_list;
        },

        getProductDeliveryRegion: function () {
            return this.product_delivery;
        },

        hidePromotionRegion: function () {
            this.getPromotionCodeRegion().reset();
        },

        hideTipsRegion: function () {
            this.getTipsRegion().reset();
        },

        hideAllowedPackageInstancesRegion: function () {
            this.getAllowedPackageInstancesRegion().reset();
        },

        hideUsedPackageInstancesRegion: function () {
            this.getUsedPackageInstancesRegion().reset();
        },

        hideRecurringFlag: function () {
            this.recurring.reset();
        },

        hideRebillingFlag: function () {
            this.rebilling.reset();
        },

        serializeData: function () {
            return {
                is_payment_allowed: this.getOption('paymentAllowed'),
                is_return: this.getOption('isReturn'),
                view_mode: this.getOption('viewMode'),
                is_payment_received: this._invoiceModel.get('payment_received'),
            };
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'invoice'
            });
        },

        onChildRender: function (){
            var $container = $('.sb_invoice_data_block').clone();
            $('.hidden', $container).remove();

            if($container.text().trim() == '' ){
                $('.invoice-pay-page-grid').addClass('--to-columns');
            } else {
                $('.invoice-pay-page-grid').removeClass('--to-columns')
            }
        }

    });

});
